import { Typography } from 'antd';
import React from 'react';
const ErrorFormField = ({ children, className, style, ...rest }) => {
    return (React.createElement(Typography.Text, { type: "danger", className: `${className || ''} font-light text-xs`, style: { display: 'block', marginTop: '4px', ...style }, ...rest }, children));
};
export default ErrorFormField;
